import React from "react";
import { Link } from "react-router-dom"
import Carousel from "../components/Carousel";
const img1 = require("../assets/IMG_0388.JPG");
const img2 = require("../assets/IMG_0426.JPG");
const img3 = require("../assets/IMG_6910.JPG");
const img4 = require("../assets/IMG_7166.JPG");

function Home() {
    const buttonStyle = {
        backgroundColor: "#073553",
        color: "white"
    }
    
    return (
        <div style={{marginTop: "86px"}}>
            <Carousel/>
            <div className="conatiner-fluid">
                <p style={{ textAlign: "center", margin: " 20px auto 40px auto", width: "90%"}}>
                    The City of Kilgore recently adopted a new Comprehensive Plan, Downtown Plan, and Thoroughfare Plan. 
                    These plans will help guide decisions and serve as a roadmap for the next 10 to 20 years. Please click 
                    the Documents tab to view the adopted plans.
                </p>
            </div>

            <div className="container text-center" style={{margin: "0px auto 15px auto"}}>
                <div className="row">
                    <div className="col-lg-3 col-sm-6" style={{marginBottom: "20px"}}>
                        <img src={img1} alt="Meetings" className="bd-placeholder-img rounded-circle" width="140" height="140"/>
                        <h3>Meetings</h3>
                        <p>Stay up to date with the latest meetings, events, and other opportunities to provide input.</p>
                        <Link to="/meetings"><button className="btn" style={buttonStyle}>View Details &raquo;</button></Link>
                    </div>

                    <div className="col-lg-3 col-sm-6" style={{marginBottom: "20px"}}>
                        <img src={img2} alt="Survey" className="bd-placeholder-img rounded-circle" width="140" height="140"/>
                        <h3>Survey</h3>
                        <p>The online survey is now closed. Thanks to everyone who participated!</p>
                    </div>

                    <div className="col-lg-3 col-sm-6" style={{marginBottom: "20px"}}>
                        <img src={img3} alt="Documents" className="bd-placeholder-img rounded-circle" width="140" height="140"/>
                        <h3>Documents</h3>
                        <p>View adopted plans</p>
                        <Link to="/documents"><button className="btn" style={buttonStyle}>View Documents &raquo;</button></Link>
                    </div>

                    <div className="col-lg-3 col-sm-6" style={{marginBottom: "20px"}}>
                        <img src={img4} alt="Comment" className="bd-placeholder-img rounded-circle" width="140" height="140"/>
                        <h3>Comment</h3>
                        <p>If you would like to share comments, request additional information, or sign up to receive future updates, please provide your email address and send us a comment.</p>
                        <Link to="/comment"><button className="btn" style={buttonStyle}>Send Us A Comment &raquo;</button></Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;